import React from "react";
import style from "../Style.module.css";

const Pattern1 = ({ color = "#000", ...props }) => {
  return (
    <svg
      className={style.svgBackground}
      height="100%"
      viewBox="10 0 237 346"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin meet"
      style={{ color }}
      {...props}
    >
      <path
        d="M237 61.8333C237 27.6355 213.157 0 183.83 0H0V123.667V247.333V371H183.83C213.236 371 237 343.272 237 309.167C237 274.969 213.157 247.333 183.83 247.333C213.236 247.333 237 219.605 237 185.5C237 151.302 213.157 123.667 183.83 123.667C213.157 123.667 237 95.9387 237 61.8333Z"
        fill="currentColor"
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern1;
